// extracted by mini-css-extract-plugin
module.exports = {"colorBar":"ColorBar_colorBar__uYwiG"};